import { flow } from 'fp-ts/function';
import { get, has } from 'lodash/fp';
import { createSelector } from 'reselect';

import { getOrFalse } from '@mews/fp';

import { Checkout } from '..';
import { getReservationPricesData } from '../../../modules/entities/reservationPrices/selectors';
import { getCurrentReservationGroupId } from '../../../modules/entities/reservations/selectors';
import { parentSelector } from '../../../selectors/parentSelector';
import { ApplicationState } from '../../../types';

export const getCheckout = createSelector<ApplicationState, ApplicationState, Checkout>(
    parentSelector,
    get('checkout')
);

export const isCheckoutFetching = flow(getCheckout, get('isFetching'), Boolean);
export const isCheckoutPreparing = flow(getCheckout, get('isPreparing'), Boolean);

export const getCustomerValues = flow(getCheckout, (checkout) => checkout?.customerValues ?? {});
export const getCustomerEmail = flow(getCustomerValues, get('email'));
export const getCustomerFirstName = flow(getCustomerValues, get('firstName'));
export const getCustomerLastName = flow(getCustomerValues, get('lastName'));
export const getCustomerPhone = flow(getCustomerValues, get('phone'));
export const getCustomerAddress = flow(getCustomerValues, get('address'));
export const getCustomerCity = flow(getCustomerValues, get('city'));
export const getCustomerPostalCode = flow(getCustomerValues, get('postalCode'));
export const getCustomerNationalityCode = flow(getCustomerValues, get('nationalityCode'));
export const getCustomerNotes = flow(getCustomerValues, get('notes'));

export const getSendMarketingEmails = flow(getCustomerValues, get('sendMarketingEmails'));
export const getBookerEmail = flow(getCustomerValues, get('bookerEmail'));
export const getBookerFirstName = flow(getCustomerValues, get('bookerFirstName'));
export const getBookerLastName = flow(getCustomerValues, get('bookerLastName'));
export const getBookerPhone = flow(getCustomerValues, get('bookerPhone'));

export const hasReservationsPrices = createSelector(getCurrentReservationGroupId, getReservationPricesData, has);

export const isBookerEnabled = flow(getCustomerValues, getOrFalse('booker'));
